<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  shopName: string
  canCreate: boolean
  teamsLoading: boolean
  checkingShops: boolean
  hasTeams: boolean
  teamName?: string
}>()

defineEmits<{
  'update:shopName': [value: string]
  'create': []
}>()

const { t } = useI18n()
</script>

<template>
  <div>
    <v-text-field
      :model-value="shopName"
      :label="t('home.shopName')"
      :hint="t('home.shopNameHint')"
      :placeholder="t('home.shopNamePlaceholder')"
      variant="outlined"
      rounded
      clearable
      class="mb-4"
      @update:model-value="$emit('update:shopName', $event)"
      @keyup.enter="$emit('create')"
    />

    <div v-if="teamsLoading" class="text-center mb-4">
      <v-progress-circular indeterminate color="primary" class="mb-2" />
      <p class="text-caption">{{ t('home.loadingTeams') }}</p>
    </div>

    <div v-else-if="checkingShops" class="text-center mb-4">
      <v-progress-circular indeterminate color="primary" class="mb-2" />
      <p class="text-caption">{{ t('home.checkingShops') }}</p>
    </div>

    <v-alert
      v-else-if="hasTeams && teamName"
      type="info"
      variant="tonal"
      class="mb-4"
      :title="t('home.teamInfo')"
      :text="t('home.teamInfoMessage', { teamName })"
    />

    <v-btn
      @click="$emit('create')"
      :disabled="!canCreate"
      color="primary"
      variant="flat"
      size="large"
      block
      class="text-none"
      prepend-icon="mdi-store-plus"
    >
      {{ t('home.createShop') }}
    </v-btn>
  </div>
</template>


